import { actions } from '../constants/clearance_info_light_box/action';
import Dispatcher from '../dispatcher';

function setSidebarBottomStyle(displayValue) {
  const sidebarBottom = document.querySelector('#sidebar-bottom');

  if (sidebarBottom) {
    sidebarBottom.style.cssText = `display:${displayValue} !important`;
  }
}

export const show = (isAddToCart, isFittingStation) => {
  setSidebarBottomStyle('none');
  Dispatcher.handleInfoLightBoxAction({
    type: actions.SHOW,
    payload: { isAddToCart, isFittingStation },
  });
};

export const hide = () => {
  setSidebarBottomStyle('flex');
  Dispatcher.handleInfoLightBoxAction({ type: actions.HIDE });
};
